module.exports = __webpack_public_path__ + "img/36_6.b8b8bca9.png";